import { EnumValues } from "@hex/common";

export namespace ContextWorkbenchPublish {
  export const View = {
    CHANGES: "changes",
    ASK_PREVIEW: "ask-preview",
  } as const;
  export type View = EnumValues<typeof View>;
  export const ChangesFilter = {
    ALL: "all",
    CHANGED: "changed",
  } as const;
  export type ChangesFilter = EnumValues<typeof ChangesFilter>;
}
